define(["require", "exports", "./context"], function (require, exports, context_1) {
    "use strict";
    exports.__esModule = true;
    var History = (function () {
        function History() {
            this.supported = false;
            this.supported = context_1["default"].supportHistory();
        }
        History.prototype.push = function (leaf, onpop) {
            if (this.supported) {
                var parent_1 = window.location.pathname;
                var isquery = leaf.startsWith("?");
                var path = isquery || parent_1.endsWith("/")
                    ? "" + parent_1 + leaf
                    : parent_1 + "/" + leaf;
                window.history.pushState(undefined, undefined, path);
                if (onpop) {
                    var current_1 = window.onpopstate;
                    window.onpopstate = function () {
                        onpop();
                        window.onpopstate = current_1;
                    };
                }
            }
        };
        History.prototype.pop = function () {
            window.history.back();
        };
        History.prototype.replace = function (href) {
            window.history.replaceState(undefined, undefined, href);
        };
        return History;
    }());
    var _history = new History();
    exports["default"] = _history;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/history.js
// module id = 4
// module chunks = 0